import { motion, AnimatePresence } from "framer-motion";
import { useAudio } from "@/components/audio-provider";
import { getDailyQuote } from "@/lib/quotes";

// The daily quote lives in the header center (where Now Playing sits) and
// reveals word-by-word — a soft blur + rise stagger that's subtle at rest
// but obvious as it animates in. It's absolutely positioned so it never
// pushes the Now Playing pill out of center during the crossfade.
//
// Each word is its own inline-block so it can carry a y/blur transform
// (transforms don't apply to plain inline text). A regular trailing space
// collapses at the inline-block boundary, so words are joined with a
// non-breaking space (" ") to keep them readable.
export function HeaderQuote() {
  const { nowPlaying } = useAudio();
  const quote = getDailyQuote();
  const words = quote.split(" ");

  return (
    <AnimatePresence>
      {!nowPlaying && (
        <motion.p
          key="header-quote"
          aria-label={quote}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.18 } }}
          className="pointer-events-none absolute inset-x-0 top-1/2 hidden -translate-y-1/2 select-none overflow-hidden whitespace-nowrap text-center font-mono text-xs italic tracking-wide text-fog/70 lg:block [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]"
        >
          <span aria-hidden="true" className="text-fog/40">
            &ldquo;
          </span>
          {words.map((w, i) => (
            <motion.span
              key={i}
              aria-hidden="true"
              className="inline-block"
              initial={{ opacity: 0, y: 7, filter: "blur(4px)" }}
              animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
              transition={{ delay: 0.18 + i * 0.045, duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            >
              {w}
              {i < words.length - 1 ? " " : ""}
            </motion.span>
          ))}
          <span aria-hidden="true" className="text-fog/40">
            &rdquo;
          </span>
        </motion.p>
      )}
    </AnimatePresence>
  );
}
